(function ($) {
    $(function () {
        // look for honeypots and hide them form regular users
        // we just hope, that bots don't like to wait for javascript
        setTimeout(function () {
            var $honepots = $('.wpcf7-form input[name="website"][type="text"], .wpcf7-form input[name="receiver-email"][type="email"]');
            $honepots.closest('label').css('display', 'none');
        }, 150);
    });
})(jQuery);
